<template>
  <!--  -->
  <div
    class="consumption_centent"
    v-infinite-scroll="getLoadData"
    infinite-scroll-disabled="busy"
    infinite-scroll-distance="10"
  >
    <!-- <div class="nav">
      <div class="nav_ret" @click="ret">
        <img class="nav_ret_img" src="@/img/back.png" alt="" />
      </div>
      <div class="nav_title">{{ $t("boon.sing") }}</div>
    </div> -->

    <navBar :text="$t('boon.sing')"></navBar>
    <div class="topup_list" v-if="!loadmore">
      <loading></loading>
    </div>
    <!--   -->
    <div
      style="min-height: 100%; "
      class=" seek_centent_no_data "
      v-if="list.length <= 0 && busy"
    >
      <div class="no_data_result">
        <div class="no_data_url">
          <img class="no_data_img" src="@/img/tag_air.png" alt />
        </div>
        <!-- -->
        <div class="no_data_text">{{ $t("config.No_result") }}</div>
      </div>
    </div>
    <!-- v-else -->
    <div class="consumption_list" v-for="(item, index) in list">
      <div class="consumption_list_show">
        <div class="consumption_list_left">
          <!-- <div class="consumption_list_gold"> -->
          <!-- <img class="consumption_list_gold_img" src="@/img/Diamonds.png" alt /> -->
          <!-- </div> -->
          <div class="consumption_list_consumption">
            <div class="consumption_list_consumption_title">
              {{ item.name }}
            </div>
            <!-- 2021/2/24 11:11 -->
            <div class="consumption_list_sum">{{ NewData(item.date) }}</div>
          </div>
        </div>
        <!-- stop -->
        <div class="sum">
          {{ item.coin }}
          <img class="sum_img" src="@/img/coin.png" alt="" />
        </div>
      </div>
    </div>

    <div class="more_game" v-if="list.length > 0">
      <div class="more_game_height1"></div>
      <div class="loading" v-if="!busy">
        <img class="loading_img" src="@/img/loading.gif" />
        <span class="loading_text">{{ $t("config.loading") }}</span>
      </div>
      <div v-if="busy">
        {{ $t("config.no_loading") }}
      </div>
      <div class="more_game_height"></div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import infiniteScroll from "vue-infinite-scroll";
import debounce from "lodash.debounce";
import configs from "@/config/config.js";
import loading from "@/components/config/loading.vue";
import navBar from "@/components/nav/navBar";
export default {
  components: {
    loading,
    navBar
  },
  // props: ["gameId"],
  directives: {
    infiniteScroll
  },

  data() {
    return {
      offset: 0,
      count: 20,
      busy: false,
      list: [],
      loadmore: false
    };
  },
  watch: {},
  computed: {},
  created() {
    console.log("re22222s");
    this.getLoadData = debounce(this._getLoadData, 50);
    // this.getLoadData = debounce(this._getLoadData, 10);
  },

  mounted() {
    this.$nextTick(function() {
      this.getLoadData();
    });
  },
  methods: {
    ...mapActions("game", ["CoinList"]),
    NewData(data) {
      return configs.NewData(data);
    },

    async _getLoadData() {
      if (this.busy) {
        return;
      }
      // this.page++;
      // this.busy = true;
      // this.loadmore = true;
      const res = await this.CoinList({
        $axios: this.$axios,
        type: 0,
        offset: this.offset,
        count: this.count,
        coinType: "gold"
      });

      console.log("res", res);
      if (res.stateCode == 1) {
        this.loadmore = true;
        this.offset = this.offset + 1;
        const rList = res.resultInfo.data || [];
        if (this.offset >= 1) {
          this.list = [...this.list, ...rList];
        } else {
          this.list = rList;
        }
        this.busy = res.resultInfo.lastPage;
      }
    },

    // 后退
    ret() {
      this.$router.go(-1);
      // if(window.TgaBridge){
      //   TgaBridge.finishPage('close')
      // }else{
      //   this.$router.go(-1);
      // }
    }
  }
};
</script>

<style scoped="scoped">
.consumption_centent {
  padding-top: 1.5rem;
  /* margin-top: 1.72rem; */
  /* position: absolute; */
  /* top: 1.6rem; */
  /* left: 0; */
  /* bottom: 0; */
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: var(--bg);
  border-radius: 0.48rem 0.48rem 0 0;
  /* padding: 0.49rem 0.49rem 0 0.39rem; */
}

.nav {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 1.5rem;
  background-color: #ffffff;
}
.nav_ret {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.61rem 0.52rem;
  z-index: 2;
}
.nav_ret_img {
  width: 0.29rem;
  height: 0.5rem;
  color: #1b1b1b;
  font-size: 0.45rem;
  font-weight: bold;
}
.nav_title {
  height: 100%;
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.consumption_list {
  /* border-top: 0.01rem solid #eaeeef; */
  padding: 0 0.55rem 0 0.48rem;
}
.consumption_centent .consumption_list:nth-of-type(1) {
  border-top: none;
}
.consumption_list_show {
  height: 1.9rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.consumption_list_left {
  display: flex;
}
.consumption_list_gold {
  margin-right: 0.44rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.consumption_list_gold_img {
  width: 0.84rem;
  height: 0.84rem;
}
.consumption_list_consumption {
}
.consumption_list_consumption_title {
  width: 6rem;
  font-size: 0.42rem;
  color: var(--recordListTitleColor);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.consumption_list_sum {
  margin-top: 0.05rem;
  font-size: 0.3rem;
  color: #999999;
}

.sum {
  color: #ff343d;
  font-size: 0.42rem;
  display: flex;
  align-items: center;
}
.sum_img {
  margin-left: 0.1rem;
  width: 0.46rem;
  height: 0.46rem;
}

.more_game {
  box-sizing: border-box;
  font-size: 0.25rem;
  width: 100%;
  text-align: center;
  color: var(--rankmore);
  /* padding-top: 0.41rem; */
  /* margin-top: 0.41rem;
       margin-bottom: 1.50rem; */
  opacity: 0.3;
  background-color: var(--bg);
}
.more_game_height {
  width: 100%;
  height: 1rem;
  background-color: var(--bg);
}
.more_game_height1 {
  width: 100%;
  height: 0.6rem;
  background-color: var(--bg);
}

/* 页面加载 */
.loading {
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  align-items: center;
}
.loading_img {
  width: 1rem;
  height: 1rem;
}
.seek_centent_no_data {
  box-sizing: border-box;
  display: flex;
  padding-top: 50%;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/record.vue